import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { checkVersionRequest } from 'store/version/version.actions'
import { useAuth } from 'hooks/use-auth'

import classes from './style.module.css'
import { fetchCurrentUserRequest, fetchLoginSuccess } from '../../../store/users/users.actions'
import { legacyAuthPath } from '../../../routes/url-constants'

export const AuthPage: React.FC = () => {
  const dispatch = useDispatch()
  const { session, loading } = useAuth()

  useEffect(() => {
    dispatch(checkVersionRequest())
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const { bearerToken } = session || {}
  useEffect(() => {
    if (!loading && bearerToken) {
      localStorage.setItem('token', bearerToken)
      dispatch(fetchLoginSuccess())
      dispatch(fetchCurrentUserRequest())
    }
  }, [bearerToken, dispatch, loading])

  if (loading) return null

  return (
    <div className="container">
      <div className="row">
        <div className="offset-md-3 col-md-6 p-sm-0">
          <div className={classes.AuthForm} style={{ marginBottom: '5px' }}>
            <a
              className="btn btn-block btn-lg btn-primary"
              href={`${process.env.REACT_APP_V3_SERVER}/auth/login?return_to=${encodeURIComponent(window.location.href)}`}
            >
              Войти через OTK ID
            </a>
          </div>
          <a href={legacyAuthPath}>Старый способ входа</a>
        </div>
      </div>
    </div>
  )
}

export default AuthPage
